var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PMenu',{attrs:{"is-open":_vm.isOpen}},[_c('transition',{attrs:{"name":"slide-left"}},[(!_vm.activeBuild)?_c('CardsGroup',{staticClass:"p-6 sm:p-12"}):_vm._e()],1),_c('transition',{attrs:{"name":"slide-right"}},[(_vm.activeBuild)?_c('ProductsGroup',{staticClass:"p-6 sm:p-12"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }